import type { FC } from "react";
import { useTranslation } from "react-i18next";

import { Typography, Link } from "@aviary";
import type { FooterMenuLink } from "@unauthenticated/catalog/data/MenuLinks.types";

import * as styles from "../Footer.styles";

interface Props {
  menuHeading: string;
  links: FooterMenuLink[];
}

const FooterLinks: FC<Props> = ({ menuHeading, links }) => {
  const { t } = useTranslation();

  const renderLinks = () => {
    return links.map((link, i) => (
      <li key={i}>
        <Link isLight isMuted noExternalIcon isUnderLined={false} href={link.link}>
          {t(link.text)}
        </Link>
      </li>
    ));
  };

  return (
    <div>
      <Typography type="h5" css={styles.footerHeader}>
        {menuHeading}
      </Typography>
      <ul css={styles.linksList}>{renderLinks()}</ul>
    </div>
  );
};

export { FooterLinks };
